import React from 'react';

import fetch from './../fetch';

import moment from 'moment';

import utils from './../../utils';

import {Modal, message, Button} from 'antd';

const DataGrid = {
    selections: [],
    resultStateSelections: [],
    refresh: function() {

    }
}

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号', width: 75},

    {key:'orgName', label: '部门', width: 150},
    {key:'itemName', label: '评价项目', width: 130},
    {key:'realName', label: '教师', width: 70},
    {key:'dudaoName', label: '评价人', width: 80},
    {key:'className', label: '班级名称', width: 120},
    {key:'classGrade', label: '年级', width: 70},
    {key:'courseName', label: '课程名称', width: 150},
    {key:'resultScore', label: '分数', width: 70},
    {key:'resultGrade', label: '等级', width: 70},
    {key:'termName', label: '所属学期/学年', width: 130},
    {key:'evalTime', label: '预提交日期', width: 120, render: (value)=> value ? moment(new Date(value)).format('YYYY/MM/DD') :""},
    {key:'submitTime', label: '正式提交日期', width: 120, render: (value)=> value ? moment(new Date(value)).format('YYYY/MM/DD') : ""},
    {key:'resultState', label: '提交状态', width: 90, render:(d) => (+d === 1 ? '已正式提交' : '预提交')},
    {key:'submitState', label: '操作', width: 90,  
    render:(d, row, callback) => (+row.resultState === 1 ? 
    (row.backFlag === false ? "已提交" : <a href="javascript:;" 
    className="undo-button" 
    onClick={() => {
        
        Modal.confirm({
            title: '确定回退？',
            content: '回退后，需要重新提交。确定要回退吗？',
            okText:"确认",
            cancelText:"取消",
            onOk: () => {
                fetch.post('eval/result/batch/back', [row.id])
                .then(response => {
                    if(response.code === 200) {
                        message.success("回退成功！");
                        callback();
                    }
                });
            },
            onCancel: () => {},
        });

    }}>回退</a> ): <a href="javascript:;" 
    className="sumbit-button"
    onClick={() => {
        Modal.confirm({
            title: '确定正式提交？',
            content: '正式提交后，将不能修改。确定要正式提交吗？',
            okText:"确认",
            cancelText:"取消",
            onOk: () => {
                fetch.post('eval/result/batch/submit', [row.id])
                .then(response => {
                    if(response.code === 200) {
                        message.success("提交成功！");
                        callback();
                    }
                });
            },
            onCancel: () => {},
        });
        
    }}
    >正式提交</a>)}
]);



/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('listenmanagerresult/list', Object.assign(defaultsParams, keywords))
    .then(response => {
        return {
            data: response.payload.data,
            backFlag: response.payload.meta.extParams.backFlag,
            meta: response.payload.meta
        };
    })
    .then(response => (Object.assign({
        result: (response.data.dataList || []).map(item => {
            return Object.assign(item, {
                backFlag: response.backFlag
            })
        }),
        selects: (response.data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        meta: response.meta,
        checked: false,
        total: response.data.total,
        pageIndex: response.data.pageNum,
        pageSize: response.data.pageSize,
        notify: (response.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method batchSubmit
 * @return {promise}
 */
const batchSubmit = (callback) => {
    return fetch.post('eval/result/batch/submit', DataGrid.selections)
    .then(response => {
        if(response.code === 200) {
            message.success("提交成功！");
            callback();
        }
    });
}

/**
 * @method batchBack
 * @return {promise}
 */
const batchBack = (callback) => {
    return fetch.post('eval/result/batch/back', DataGrid.selections)
    .then(response => {
        if(response.code === 200) {
            message.success("回退成功！");
        }

        callback();
        return response;
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('eval/result/remove', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback) => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        callback();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onResultStateSelect = (ids) => {
    DataGrid.resultStateSelections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getResultStateSelect = () => {
    return DataGrid.resultStateSelections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'eval/result'+ url;
};

const getSelection =() => {
    return DataGrid.selections;
}

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

export default {
    querySearch,
    batchSubmit,
    batchBack,
    remove,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    getSelection,
    onResultStateSelect,
    getResultStateSelect
}